<template>
	<FieldSet :label="label" :infoText="infoText" :required="required">
		<SalesChannelSelector
			:modelValue="modelValue"
			:clients="clients"
			:propClientAssignments="propClientAssignments"
			:serviceProvider="serviceProvider"
			:dataCy="dataCy"
			:app="app"
			:clientAssignmentLocked="clientAssignmentLocked"
			:isWaiting="isWaiting"
			:locked="locked"
			@update:modelValue="$emit('update:modelValue', $event)"
		/>
	</FieldSet>
</template>

<script>
import FieldSet from '../../views/applications/packageDesigner/FieldSet.vue'
import SalesChannelSelector from './SalesChannelSelector.vue'

export default {
	name: 'SalesChannelsSection',
	components: { FieldSet, SalesChannelSelector },
	props: {
		label: String,
		infoText: String,
		required: Boolean,
		modelValue: Array,
		clients: Array,
		propClientAssignments: Array,
		serviceProvider: Object,
		dataCy: String,
		app: String,
		clientAssignmentLocked: Boolean,
		isWaiting: Boolean,
		locked: Boolean,
	},
	emits: ['update:modelValue'],
}
</script>
